import { useRef } from "react";

export function useMenuRefs() {
  const refs = useRef({});

  const setRef = (id) => (element) => {
    refs.current[id] = element;
  };

  const focusElement = (id) => {
    refs.current[id]?.focus();
  };

  return { setRef, focusElement };
}
